import moment from "moment";
import styled from "styled-components";
import TourGroupItem from "./TourGroupItem";

//------------------------------------------------------------------------

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const DateHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px;
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(5px);
  position: sticky;
  top: 0;
  z-index: 10;
  span {
    font-size: 0.8rem;
  }
`;

const HeaderDateText = styled.span`
  font-size: 0.9rem;
  font-weight: bold;
  color: black;
`;

const HeaderGroupsText = styled.span`
  font-size: 0.8rem;
  color: #666;
`;

const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

//------------------------------------------------------------------------

export interface ITourGroupItem {
  tour_group_id: string;
  date: string;
  isCancelled: boolean;
  product_id: string;
  option_id: string;
  start_time_id: string;
  index: number;
  seatsCount: number;
  external_assignments: {
    _id: string;
    role_id: string;
    user_id: string;
  }[];
  external_assignments_notes: {
    _id: string;
    user_id: string;
    body: string;
    date: Date;
  }[];
  allRolesFilled: boolean;
}

interface TourGroupsDateSectionItemProps {
  date: string;
  data: ITourGroupItem[];
  refetch: () => void;
  isMultiSelectMode?: boolean;
  onItemSelection?: (
    item: {
      option_id: string;
      start_time_id: string;
      date: string;
      tour_group_id: string;
      product_id: string;
    },
    selected: boolean
  ) => void;
  selectedItems?: Array<{
    option_id: string;
    start_time_id: string;
    date: string;
    tour_group_id: string;
    product_id: string;
  }>;
}

const TourGroupsDateSectionItem = ({
  date,
  data,
  refetch,
  isMultiSelectMode = false,
  onItemSelection = () => {},
  selectedItems = [],
}: TourGroupsDateSectionItemProps) => {
  return (
    <Container>
      <DateHeaderContainer>
        <HeaderDateText>
          {moment(date).format("ddd, DD MMM YYYY")}
        </HeaderDateText>
        <HeaderGroupsText>
          {data.length} Groups
          {isMultiSelectMode && selectedItems.length > 0
            ? ` (${
                selectedItems.filter((item) =>
                  data.some(
                    (dataItem) => dataItem.tour_group_id === item.tour_group_id
                  )
                ).length
              } selected)`
            : ""}
        </HeaderGroupsText>
      </DateHeaderContainer>
      <DataContainer>
        {data.map((item) => {
          const isItemSelected = selectedItems.some(
            (selectedItem) => selectedItem.tour_group_id === item.tour_group_id
          );

          return (
            <TourGroupItem
              key={item.tour_group_id}
              item={item}
              refetch={refetch}
              isMultiSelectMode={isMultiSelectMode}
              onItemSelection={onItemSelection}
              isSelected={isItemSelected}
              date={date}
            />
          );
        })}

        {data.length === 0 && <span>No data available for this date.</span>}
      </DataContainer>
    </Container>
  );
};

export default TourGroupsDateSectionItem;
